import apiClient from '../utils/apiClient';

/**
 * Category API Services
 * Quản lý danh mục món ăn
 */

const buildCategoryPayload = (data = {}) => {
  const payload = {};
  if (data.name !== undefined) payload.name = data.name;
  if (data.slug !== undefined) payload.slug = data.slug;
  if (data.description !== undefined) payload.description = data.description;
  if (data.image !== undefined) payload.image = data.image;
  if (data.displayOrder !== undefined) payload.display_order = data.displayOrder;
  if (data.isActive !== undefined) payload.is_active = data.isActive;
  return payload;
};

export const categoryAPI = {
  /**
   * Lấy danh sách tất cả danh mục
   * @returns {Promise<Object>} Danh sách danh mục
   */
  getCategories: async () => {
    return await apiClient.get({
      url: '/categories',
    });
  },

  /**
   * Lấy thông tin chi tiết một danh mục
   * @param {string} categoryId - ID danh mục
   * @returns {Promise<Object>} Thông tin chi tiết danh mục
   */
  getCategoryById: async (categoryId) => {
    return await apiClient.get({
      url: `/categories/${categoryId}`,
    });
  },

  /**
   * Tạo danh mục mới
   * @param {Object} categoryData - Dữ liệu danh mục
   * @param {string} categoryData.name - Tên danh mục
   * @param {string} categoryData.slug - Slug danh mục
   * @param {string} categoryData.description - Mô tả
   * @param {string} categoryData.image - URL hình ảnh
   * @param {number} categoryData.displayOrder - Thứ tự hiển thị
   * @param {boolean} categoryData.isActive - Trạng thái hoạt động
   * @returns {Promise<Object>} Thông tin danh mục vừa tạo
   */
  createCategory: async (categoryData) => {
    return await apiClient.post({
      url: '/categories',
      data: buildCategoryPayload(categoryData),
    });
  },

  /**
   * Cập nhật thông tin danh mục
   * @param {string} categoryId - ID danh mục
   * @param {Object} updateData - Dữ liệu cập nhật
   * @returns {Promise<Object>} Thông tin danh mục sau khi cập nhật
   */
  updateCategory: async (categoryId, updateData) => {
    return await apiClient.put({
      url: `/categories/${categoryId}`,
      data: buildCategoryPayload(updateData),
    });
  },

  /**
   * Xóa danh mục (cascade xóa món trong danh mục)
   * @param {string} categoryId - ID danh mục
   * @returns {Promise<Object>} Kết quả xóa
   */
  deleteCategory: async (categoryId) => {
    return await apiClient.delete({
      url: `/categories/${categoryId}`,
    });
  },

  /**
   * Sắp xếp lại thứ tự danh mục
   * @param {Array<string>} categoryIds - Mảng ID danh mục theo thứ tự mới
   * @returns {Promise<Object>} Kết quả sắp xếp
   */
  reorderCategories: async (categoryIds) => {
    return await apiClient.patch({
      url: '/categories/reorder',
      data: { category_ids: categoryIds },
    });
  },
};
